import React from 'react';
import {
    Box,
    Button,
    Popover,
    Grid,
    Avatar as MuiAvatar,
    lighten,
    useTheme,
} from '@material-ui/core';
import { IAvatarPopover } from './types';
import { CONTACT_AVATARS } from 'src/components/contacts/constants/images';
import { getDicebearAvatar } from 'src/utils/images/getDicebearAvatar';
import { getContactVariants } from 'src/components/contacts/constants/images';

export const AvatarPopover = ({
    open,
    onClose,
    onSelect,
    anchorEl,
}: IAvatarPopover) => {
    const theme = useTheme();

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <Box
                p={2}
                style={{
                    width: 360,
                    maxHeight: 300,
                    overflowY: 'auto',
                }}
            >
                <Grid container spacing={1}>
                    {CONTACT_AVATARS.map(({ style, seed }) => {
                        const avatarUri = getDicebearAvatar({
                            style,
                            seed,
                            variants: getContactVariants(
                                lighten(theme.palette.primary.main, 0.8)
                            ),
                        });

                        return (
                            <Grid item xs={2} key={`${style}-${seed}`}>
                                <Button
                                    onClick={() => {
                                        onSelect({
                                            style,
                                            seed,
                                        });

                                        onClose();
                                    }}
                                    style={{
                                        minWidth: 0,
                                        width: '100%',
                                        padding: 4,
                                        borderRadius: 8,
                                    }}
                                >
                                    <MuiAvatar
                                        src={avatarUri}
                                        alt={seed}
                                        style={{
                                            width: 45,
                                            height: 45,
                                        }}
                                    />
                                </Button>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>
        </Popover>
    );
};
